'use client';

import type { IStreak } from '@repo/sdk';
import { Card, CardContent, CardHeader, CardTitle } from '@repo/ui';
import { Flame } from 'lucide-react';
import type { JSX } from 'react';

export function StreakCard({ streak }: { streak: IStreak }): JSX.Element {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Flame className="h-5 w-5 text-orange-500" />
          Streak
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-baseline gap-1 mb-3">
          <span className="text-4xl font-bold">{streak.current}</span>
          <span className="text-muted-foreground text-sm">days</span>
        </div>
        <div className="flex gap-1 mb-3">
          {streak.weekDays.map((d) => (
            <div
              key={d.day}
              className={`flex flex-col items-center gap-1 flex-1 rounded-md py-1 text-xs ${
                d.isToday ? 'bg-primary/10 font-semibold' : ''
              }`}
            >
              <span className="text-muted-foreground">{d.day}</span>
              <div
                className={`w-3 h-3 rounded-full ${d.completed ? 'bg-green-500' : 'bg-muted'}`}
              />
            </div>
          ))}
        </div>
        <div className="grid grid-cols-2 gap-2 text-sm text-muted-foreground">
          <div>
            Max: <span className="font-medium text-foreground">{streak.max}</span>
          </div>
          <div>
            Active: <span className="font-medium text-foreground">{streak.totalActiveDays}d</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
